module.exports = __webpack_public_path__ + "img/wancheng-icon.eb51e122.png";